import { render, staticRenderFns } from "./CruiseDetailBlock.vue?vue&type=template&id=5aa705e9&"
import script from "./CruiseDetailBlock.vue?vue&type=script&lang=js&"
export * from "./CruiseDetailBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports